<template>
  <div class="overflow-auto bg-background w-full px-6">
    <div class="max-w-5xl mx-auto pb-12">
      <router-view />
    </div>
  </div>
</template>
